Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.GroupView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/campaign/group']
  sectionTemplate: JST['backbone/templates/monitoring/reports/campaign/section']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    renderOptions = {summary: @options.summary, engmt_evolution: @options.engmt_rate_evolution}
    @$el.html(@sectionTemplate(@options))
    @$('.data').html(@template(renderOptions))
    @$el.addClass(@options.section + '-section')
    unless @options.section == 'general'
      @$el.addClass('any-section')

    sections = [
      new Monitoring.Reports.Campaign.SentimentHistogramView(@options),
      new Monitoring.Reports.Campaign.SentimentDistributionView($.extend({}, @options, {chartTitle: "Sentiment distribution"})),
      new Monitoring.Reports.Campaign.PositiveVsNegativeView(@options),
      new Monitoring.Reports.Campaign.TagsView($.extend({}, @options, {chart: 'column', contentsByTag: true})),
      new Monitoring.Reports.Campaign.PostClassifiedView($.extend({}, @options, {contentsByTag: true})),
      new Monitoring.Reports.Campaign.SentimentByTagView(@options),
      new Monitoring.Reports.Campaign.PostClassifiedView(@options),
      new Monitoring.Reports.Campaign.TagsView($.extend({}, @options, {chart: 'column'})),
      new Monitoring.Reports.Campaign.WordsCloudView(@options)
    ]
    
    if @options.engmt_rate_evolution
      sections.push new Monitoring.Reports.Campaign.EngagementRateHistogramView($.extend({}, @options, {content_id: @options.posts, user:null, type: @options.section}))

    if @options.summary
      sections.push new Monitoring.Reports.Campaign.PostInsightsView($.extend({}, @options, {content_id: @options.posts, user:null, type: @options.section, paginate: true}))


    @pending = sections.length

    for section in sections
      section.bind('rendered', @_sectionRendered)
      section.bind('generalSectionRendered', @_generalSectionRendered)
      section.bind('twitterSectionRendered', @_twitterSectionRendered)
      section.bind('facebookSectionRendered', @_facebookSectionRendered)
      section.bind('instagramSectionRendered', @_instagramRendered)
      section.render()
      @$('[data-view=' + section.className + ']').append(section.el)

  _sectionRendered: =>
    @pending -= 1
    @trigger('rendered') if @pending == 0

  _generalSectionRendered: (wordsList) =>
    @trigger('generalSectionRendered', wordsList)

  _twitterSectionRendered: (wordsList) =>
    @trigger('twitterSectionRendered', wordsList)

  _facebookSectionRendered: (wordsList) =>
    @trigger('facebookSectionRendered', wordsList)

  _instagramRendered: (wordsList) =>
    @trigger('instagramSectionRendered', wordsList)
